import React from 'react';
import MImage from './m_image'


const EpImage = (props) => {
  return (
    <MImage
      show_lightbox={true}
      data={
        {
          uid: props.data.uid,
          spacing: props.data.spacing,
          image: {
            src: props.data.image.src,
            title: props.data.image.title,
            description: props.data.image.description,
            alternative: props.data.image.alternative,
            link: props.data.image.link
          },
          figcaption: props.data.rowDescription,
          aspect_ratio: (props.data.aspect_ratio && props.data.aspect_ratio !== undefined ? props.data.aspect_ratio : "4:3")
        }
      }
    />
  );
}

export default EpImage;
